"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _inputErrorWrapper = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/inputs/input-error-wrapper"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

var _textInput = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/inputs/text-input"));

require("./text-form-field.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // defaulted required to true because all inputs except address 2 are required


var TextFormField = function TextFormField(_ref) {
  var containerClassName = _ref.containerClassName,
      error = _ref.error,
      label = _ref.label,
      name = _ref.name,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? true : _ref$required,
      rest = _objectWithoutProperties(_ref, ["containerClassName", "error", "label", "name", "required"]);

  return _react.default.createElement("div", null, !!label && _react.default.createElement(_styledText.default, {
    className: "text-from_inputLabel"
  }, label), _react.default.createElement(_inputErrorWrapper.default, {
    containerClassName: (0, _classnames.default)('text-from_inputContainer', containerClassName),
    error: error
  }, _react.default.createElement(_formik.Field, {
    name: name
  }, function (_ref2) {
    var field = _ref2.field;
    return _react.default.createElement(_textInput.default, _extends({}, field, {
      className: "text-form_input",
      name: name,
      required: required
    }, rest));
  })));
};

var _default = TextFormField;
exports.default = _default;